<script setup lang="ts">
defineProps({
  placeholder: null
})
defineEmits(["submit"])
const text = defineModel<string>()
</script>

<template>
  <div class="dropdown-text-input">
    <interface-input
      v-model="text"
      type="text"
      :placeholder
      transparent
      no-ring
      @click.prevent.stop
      @keydown.enter="(e: KeyboardEvent) => $emit('submit', e)"
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.dropdown-text-input
  @apply
</style>
